import styled from "styled-components"

export const ScoreboardWrapper = styled.div`
  position: absolute;
  right: 10%;
  width: 18vw;
  transform: translate3d(${props => (
    props.active ? "0, 0, 1rem" : "10%, -12%, 0rem"
  )});
  transition: transform 0.2s;
  font-size: min(.7vw, 11px);
`
export const ScoreboardsWrapper = styled.div`
  transform-style: preserve-3d;
  position: absolute;
  top: 25%;
  right: 8%;
`